<template>
  <div id="engine-data-details">
    <div id="side-container">
      <div class="title-text sdf-text-20-400-white">データレポート</div>
      <div class="side-switch-area">
        <div class="side-switch sdf-text-16-400-white">
          異常値
          <vs-switch color="#EB5757" v-model="showAbnormalValue">
            <span slot="on">ON</span>
            <span slot="off">OFF</span>
          </vs-switch>
        </div>
        <div class="side-switch sdf-text-16-400-white">
          正常
          <vs-switch color="#2D9CDB" v-model="showNormalValue">
            <span slot="on">ON</span>
            <span slot="off">OFF</span>
          </vs-switch>
        </div>
      </div>
    </div>
    
    <div id="main-container">
      <div class="data-report-menu-area">
        <div class="data-report-menu-item" @click="callDownloadCsv">
          <feather-icon
            icon="FileTextIcon"
            svgClasses="h-5 w-5"
            class="mr-2 menu-item-icon"
          /><p class="sdf-text-16-400-white">CSVダウンロード</p>
        </div>
      </div>
      <div
        v-if="isCategorySelected || isCustomReportSelected"
      >
        <div id="chart-column-header" class="sdf-text-14-400-mouse-gray">
          <div class="column-header-text column-check">
            <vs-checkbox @click="checkClicked" v-model="checkAll" :color="sdfColor.Blue"></vs-checkbox>
          </div>
          <div class="column-header-text column-alerm">アラーム</div>
          <div class="column-header-text column-channel-id">CH番号</div>
          <div class="column-header-text column-channel-name">CH名</div>
          <div class="column-header-text column-value">値</div>
          <div class="column-header-text column-unit">単位</div>
          <div class="column-header-text column-status">ステイタス</div>
          <div class="column-header-text column-chart">チャート</div>
        </div>
        <engine-data-custom-report
          v-if="isCustomReportSelected"
          @refreshChannelData="refreshChannelData"
        >
        </engine-data-custom-report>
        <engine-data-chart
          :channel_data="all_channel_data"
          :xAxisValue.sync="xAxisValue"
          :showNormalValue="showNormalValue"
          :showAbnormalValue="showAbnormalValue"
          @confirmRemoveCustomId="confirmRemove"
          @changeOrder="changeOrder"
          @refreshChannelData="refreshChannelData"
          @zoomChannelTime="zoomChannelTime"
          @zoomLiveChannelTime="zoomLiveChannelTime"
          ref="child">
        </engine-data-chart>
      </div>
    </div>
    <sdf-popup class="no-select-popup" :popupActive.sync="popupActiveNoSelect">
      <p style="margin: 30px 0px;">
        ダウンロードしたいチャンネルの左側のボックスをチェックしてください
      </p>
      <vs-button class="popup-button" :color="sdfColor.MouseGray" :style="popupButtonStyle" @click="popupActiveNoSelect = false">閉じる</vs-button>
    </sdf-popup>
    <sdf-popup class="remove-confirm-popup" :popupActive.sync="popupActive">
      <p style="margin: 30px 0px;">
        {{removeTargetText}}をカスタムレポートから削除しますか？
      </p>
      <vs-button
        class="popup-button"
        color="#2D9CDB"
        :style="popupButtonStyle"
        @click="removeCustomChannelId(removeTargetId)"
      >削除
      </vs-button>
      <vs-button class="popup-button" color="transparent" :style="popupButtonStyle" @click="popupActive = false">キャンセル</vs-button>
    </sdf-popup>
  </div>
</template>

<script>
import Vue from 'vue';
import _ from "lodash";
import SecureDataflowMixin from "@/mixins/SecureDataflowMixin";
import SecureDataflowService from "@/services/secureDataflowService";
import SdfPagination from "./SdfPagination";
import SdfPopup from "../../components/SdfPopup";
import EngineDataCustomReport from "./EngineDataCustomReport";
import EngineDataChart from "./EngineDataChart";
import moment from "moment";
import {createNamespacedHelpers} from "vuex";
const { mapGetters, mapActions, mapState } = createNamespacedHelpers("monitoringVesselEngine");

export default {
  name: "engineDataDetails",
  mixins: [SecureDataflowMixin],
  components: {
    EngineDataChart,
    EngineDataCustomReport,
    SdfPagination,
    SdfPopup,
  },
  data() {
    return {
      isProcessing: false,
      on: true,
      zoomCount: 0,
      currentPage: 1,
      totalItems: 45,
      maxItems:3,
      all_channel_data:[], //このデータがAPIから返ってくる想定
      showNormalValue: true,
      showAbnormalValue: true,
      xAxisValue: 0,
      popupActive: false, // Popup用パラメータ
      removeTargetText: null,
      removeTargetId: null,
      popupButtonStyle: `
        padding: 2px 36px !important;
      `,
      checkAll: false,
      inputChannelNumber: "",
      popupActiveNoSelect: false
    }
  },
  computed: {
    ...mapGetters(["getSelectedCategory", "getCustomChannelIds", "getChannelTimeFrom", "getChannelTimeTo", "getVersion", "getChannelGroupData"]),
    ...mapState({
      mode: state => state.mode,
      channelGroupFocusPointMap: state => state.channelGroupFocusPointMap,
      channelMaster: state => state.channelMaster,
      liveDataTimeRange: state => state.liveDataTimeRange,
      unsubscribes: state => state.unsubscribes,
      unsubscribesForChart: state => state.unsubscribesForChart,
      xZoomCount: state => state.xZoomCount,
      xZoomPercentage: state => state.xZoomPercentage,
      xZoomStoredRange: state => state.xZoomStoredRange,
    }),
    isCustomReportSelected() {
      return this.getSelectedCategory === "custom";
    },
    isCategorySelected() {
      return !this.isCustomReportSelected
    },
		isIdle() {
			return this.$store.state.idleVue.isIdle;
		}
  },
  watch: {
    getSelectedCategory() {
      this.$refs.child.checkClear();
      this.checkAll = false;

      //let time_gap = moment(this.getChannelTimeTo).valueOf() - moment(this.getChannelTimeFrom).valueOf()
      //this.setZoomStoredRange(time_gap) // データ取得期間を保存
      //this.resetZoomCount()

      this.zoomChannelTime()
    },
    checkAll() {
      if (this.checkAll) {
        this.$refs.child.checkAll();
      } else {
        this.$refs.child.checkClear();
      }
    },
    xAxisValue() {
      this.setChannelGroupFocusPoint({
        channelGroup: this.getSelectedCategory,
        time: this.xAxisValue, 
      });
    },
    async isIdle() {
      let r = this.$router.resolve({
        name: "login-enterprise",
        query: { logout: "force" }
      });
      window.location.assign(r.href)
    }
  },
  methods: {
    ...mapActions([
      "setChannelGroupFocusPoint",
      "getChannelsDetailDataList",
      "setCustomChannelIdsState",
      "setVersionState",
      "downloadCsv",
      "subscribeChannelDataEngine",
      "setOriginIdState",
      "setChannelTimeFromState",
      "setChannelTimeToState",
      "setSelectedCategoryState",
      "initializeCustomChannelIds",
      "changeCustomChartOrder",
      "setZoomStoredRange",
      "addZoomCount",
      "reduceZoomCount",
      "resetZoomCount",
      "zoomInLiveChannelTime",
      "zoomOutLiveChannelTime",
      "resetLiveChannelTime"
    ]),
    /**
     * x軸ズームで開始終了時間をstate保存
     */
    async zoomChannelTime(mode) {
      if (mode == "minus") {
        this.reduceZoomCount()
      } else if(mode == "plus") {
        this.addZoomCount()
      }

      await this.setChannelTimeFromState(this.xZoomStoredRange[this.xZoomCount].from)
      await this.setChannelTimeToState(this.xZoomStoredRange[this.xZoomCount].to)

      this.$refs.child.redrawPointData()

      let start_time = moment(this.xZoomStoredRange[this.xZoomCount].from).format("HH:mm:ss")
      let end_time = moment(this.xZoomStoredRange[this.xZoomCount].to).format("HH:mm:ss")
      this.$emit('setTimeDisplay', {start_time, end_time});
    },

    async zoomLiveChannelTime(mode) {
      if (mode == "minus") {
        this.zoomOutLiveChannelTime()
        this.$emit("setLiveChannelTime")
        this.refreshChannelData()
      } else if (mode == "plus") {
        this.zoomInLiveChannelTime()
        this.$emit("setLiveChannelTime")
        this.refreshChannelData()
      }
    },
    async resetLiveChannelZoom() {
      this.resetLiveChannelTime()
      this.$emit("setLiveChannelTime")
      this.refreshChannelData()
    },
    checkClicked() {
      this.$refs.child.checkAll();
    },
    refreshChannelData() {
      if ( this.isProcessing === true ) {
        return;
      }
      this.isProcessing = true;
      this.$vs.loading({
        text: "データ取得中",
        textAfter: true,
        color: this.sdfColor.Blue,
        container: '#content-area',
      });

      this.$nextTick(async () => {
        await (async() => {
          this.$refs.child.clearDisplayMap(); // ライブで取得した値に残っているデータをクリア
          this.all_channel_data = [];
          const kind = this.getSelectedCategory === "maneuvering" ? "handling" : "engine";
          let channels = null;

          if (this.getSelectedCategory === "custom") {
            if ( !this.getCustomChannelIds || this.getCustomChannelIds.length === 0 ) {
              channels = await this.initializeCustomChannelIds();
            } else {
              channels = this.getCustomChannelIds;
            }
            let engineChannels = channels.filter(element => element.kind == "engine")
            let handlingChannels = channels.filter(element => element.kind == "handling")
            let engineChannelData = await this.getChannelDetailData("engine", engineChannels);
            let handlingChannelData = await this.getChannelDetailData("handling", handlingChannels);
            let channelsData = [...engineChannelData, ...handlingChannelData]
            channelsData = channelsData.sort(function(a,b) {
              if (a.order < b.order) return -1
              if (a.order > b.order) return 1
              return 0
            })
            this.all_channel_data = channelsData
          } else {
            this.all_channel_data = await this.getChannelDetailData(kind, channels);
          }
        })().finally(() => {
          this.$vs.loading.close('#content-area > .con-vs-loading')
          this.isProcessing = false;
        })
      });
    },


    /**
     *  データを取得し、this.all_channel_dataに埋め込むメソッド.
     */
    async getChannelDetailData(kind, channels) {
      const vessel = await SecureDataflowService.getVessel();

      // channelsに直接対象チャンネルのchannel_idが指定されていなければ、ChannelGroupDataのchannelsを参照する
      let index = _.findIndex(this.getChannelGroupData, (o) => { return o.channelGroup === this.getSelectedCategory });
      let targetChannels = ( channels === null || channels.length === 0 ) ? Object.keys(this.getChannelGroupData[Number(index)].channels) : channels;
      let version = this.getVersion;
      let payload = {
        origin_id: version[kind].originId,
        kind: kind,
        version_id: version[kind].versionId,
        vessel_id: vessel.vessel_info.id,
        channel_ids: targetChannels,
        channel_group: this.getSelectedCategory,
      };

      return await this.getChannelsDetailDataList(payload).catch(error => {
        this.$vs.notify({
          title: `データ取得に失敗しました。時間をおいて再度お試しください。`,
          color:'warning',
          iconPack: "feather",
          icon: "icon-x-square"
        });
        this.$vs.loading.close('#content-area > .con-vs-loading');
        return Promise.reject(error)
      });
    },


    async callDownloadCsv() {
      let checkedChannels = this.$refs.child.checkedChannels;
      let channelListWithVersion = [];
      let version = this.getVersion;
      Object.keys(checkedChannels).forEach(key => {
        checkedChannels[key].forEach(channelId => {
          channelListWithVersion.push({
            version_id: version[key].versionId,
            channel_id: channelId,
          });
        });
      });
      if (channelListWithVersion.length != 0) {
        const vessel = await SecureDataflowService.getVessel();
        let now = moment().utc().format("YYYY-MM-DDTHH:mm:ss") + ".000Z";

        let liveDataTimeRange = this.liveDataTimeRange ? this.liveDataTimeRange : 60;
        let liveTimeFrom = moment().utc().subtract(liveDataTimeRange, "minutes").format("HH:mm:ss");
        let liveDateTimeFrom = moment().utc().subtract(liveDataTimeRange, "minutes").format("YYYY-MM-DD") + "T" + liveTimeFrom + ".000Z";

        let time_from = this.mode === "live" ? liveDateTimeFrom : this.getChannelTimeFrom;
        let time_to = this.mode === "live" ? now : this.getChannelTimeTo;

        let payload = {
          vessel_id: vessel.vessel_info.id,
          body: {
            channel_time_from: time_from,
            channel_time_to: time_to,
            channels: channelListWithVersion,
          }
        }
        try {
          let res = await this.downloadCsv(payload);
          const blob = new Blob([res.data], { type: "text/csv" });
          const uri = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.download = `data.csv`;
          link.href = uri;
          link.click();
          this.$vs.loading.close();
        } catch (e) {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "ダウンロードに失敗しました",
            color: "danger",
            iconPack: "feather",
            icon: "icon-x-square"
          });
        }
      } else {
        this.popupActiveNoSelect = true
      }
    },
    async removeCustomChannelId(id) {
      let newChannelIds = [...this.getCustomChannelIds].filter(n => n.id !== id);
      this.setCustomChannelIdsState(newChannelIds);
      this.popupActive = false;
      this.refreshChannelData();
    },
    confirmRemove(obj) {
      this.removeTargetText = obj.channel_id + " " + obj.channel_name;
      this.removeTargetId = obj.channel_id;
      this.popupActive = true;
    },
    async changeOrder(data) {
      await this.changeCustomChartOrder(data)
      this.refreshChannelData();
    },
    openPopup3d() {
      if (this.isAlertSummarySelected) {
        this.popupActive3d = true;
        let checkedChannels = this.$refs.child.checkedChannels;
        this.inputChannelNumber = checkedChannels["engine"].join();
      }
    },
    async callDownloadCsv3d() {
      if (this.inputChannelNumber.length != 0) {
        let version = this.getVersion;
        let kind = "engine";
        let channelList = this.inputChannelNumber.split(',');
        const vessel = await SecureDataflowService.getVessel();

        let now = moment().utc().format("YYYY-MM-DDTHH:mm:ss") + ".000Z";

        let liveDataTimeRange = this.liveDataTimeRange ? this.liveDataTimeRange : 60;
        let liveTimeFrom = moment().utc().subtract(liveDataTimeRange, "minutes").format("HH:mm:ss");
        let liveDateTimeFrom = moment().utc().subtract(liveDataTimeRange, "minutes").format("YYYY-MM-DD") + "T" + liveTimeFrom + ".000Z";

        let time_from = this.mode === "live" ? liveDateTimeFrom : this.getChannelTimeFrom;
        let time_to = this.mode === "live" ? now : this.getChannelTimeTo;

        let payload = {
          vessel_id: vessel.vessel_info.id,
          body: {
            origin: version[kind].originId,
            kind: kind,
            version_id: version[kind].versionId,
            channel_time_from: time_from,
            channel_time_to: time_to,
            channel_ids: channelList,
          }
        };
        try {
          let res = await this.download3dCsv(payload);
          const blob = new Blob([res.data], { type: "text/csv" });
          const uri = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.download = `alarm_data.csv`;
          link.href = uri;
          link.click();
          this.$vs.loading.close();
        } catch (e) {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "ダウンロードに失敗しました",
            color: "danger",
            iconPack: "feather",
            icon: "icon-x-square"
          });
        }
      }
    },
    openFitViewer() {
      this.popupActive3d = false;
      window.open('fitviewer:', '_blank');
    },
  },
}
</script>

<style lang="scss">
@import "@/assets/scss/secure-dataflow/_variables.scss";

#engine-data-details{
  background-color: $dark-blue-navy;
  color: $white;
  min-height: calc(100vh - 251px);
  display: flex;
  #side-container {
    width: 250px;
    padding: 30px;
  }

  .menu-item-icon {
    position: absolute;
    margin-top: 3px;
  }

  .effect {
    background: $blue !important;
  }
  .vs-pagination--buttons {
    background: transparent !important;
    color: $white;
  }

  .vs-pagination--ul {
    background: $navy;
  }
  .vs-pagination--li {
    color: $white;
  }

  #main-container {
    width: 100%;
    padding-left: 30px;
  }
  .control-area {
    display: flex;
  }
  .data-report-menu-area {
    display: flex;
    justify-content: flex-end;
  }

  .data-report-menu-item {
    margin: 20px;
    cursor: pointer;
    p {
      font-size: 16px;
      padding-left: 29px;
    }
  }

  .side-switch {
    margin-top: 20px;
    margin-bottom: 30px;
    display: flex;
    flex-flow: wrap;
    justify-content: space-between;
    width: 120px;
  }
  .side-switch-area {
    margin-top: 40px;
  }
  .side-menu-item {
    margin-top: 10px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
  }
  .engine-data-chart-container {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  #chart-column-header {
    display: flex;
    border-bottom: solid;
    border-width: 1px;
    border-color: $gray;
  }

  .column-check {
    padding-left: 13px;
    min-width: 60px;
  }
  .column-alerm {
    min-width: 70px;
  }
  .column-channel-id {
    min-width: 60px;
  }
  .column-channel-name {
    width: 220px;
  }
  .column-value {
    min-width: 180px;
  }
  .column-unit {
    min-width: 80px;
  }
  .column-status {
    min-width: 80px;
  }
  .column-chart {
    min-width: 220px;
  }
  .column-date {
    min-width: 190px;
  }
  .column-id {
    min-width: 120px;
  }
  .column-alert-name, .column-event-name {
    min-width: 600px;
  }
  .column-alert-value, .column-event-value {
    min-width: 120px;
  }
  .column-alert-status, .column-event-status {
    min-width: 130px;
  }
  .column-3d {
    min-width: 100px;
  }
  .pagination {
    float: right;
  }
  .item-disabled {
    cursor: default;
    color: #888888;
    p {
      color: #888888;
    }
  }
}
</style>
